import Home from './Home';
import Footer from './Footer';
function App() {
  return (
    <>
      <Home />;
      <Footer />
    </>
  );
}

export default App;
